export const GTA_LP_URL = 'https://lp.wabunka-lux.jp/tailoredjapantravel';
